import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
    useNavigate,
    IconType,
    PageFrame,
    ResultScreen,
} from '@alfa-retail-react/components';

import { useApplicationContext } from 'app/store/сontext/ApplicationContext';
import { UNEXPECTED_ERROR_PAGE_URL } from 'app/logic/pages/error/UnexpectedErrorPage';

export interface ErrorPageState {
    /**
     * Заголовок страницы
     */
    title?: string;

    /**
     * Сообщение ошибки.
     */
    messages?: Array<string>;

    /**
     * Текст кнопки действия
     */
    actionButtonText?: string;

    /**
     * Обработчик нажатия по кнопке действия
     */
    actionHandler?: () => void;
}

/**
 * Путь к странице ошибки.
 */
export const ERROR_PAGE_URL: string = '/error';

const DEFAULT_ACTION_BUTTON_TEXT = 'Закрыть';
const defaultActionHandler = () => {
    window.location.href = (window as any).env.REFERER_URL;
};

/**
 * Страница ошибки.
 */
export const ErrorPage = () => {
    const state = useLocation().state as ErrorPageState;
    const { title, messages } = state;
    const navigate = useNavigate();
    const applicationContext = useApplicationContext();
    const actionButtonText =
        state.actionButtonText || DEFAULT_ACTION_BUTTON_TEXT;
    const onClickActionButton = state.actionHandler || defaultActionHandler;

    useEffect(() => {
        if (!state || !title || !messages) {
            navigate<ErrorPageState>(UNEXPECTED_ERROR_PAGE_URL, {
                actionHandler: () => {
                    navigate(-2);
                },
            });
        }
    }, []);

    return (
        <PageFrame
            rightAddonLogo={applicationContext.additionalLogo}
            displayFooter
        >
            <ResultScreen>
                <ResultScreen.Icon iconType={IconType.ERROR} />
                <ResultScreen.Header title={state.title} />
                <ResultScreen.ContentBar messages={state.messages} />
                <ResultScreen.ActionBar
                    actionButtons={[
                        {
                            children: actionButtonText,
                            onClick: onClickActionButton,
                            view: 'accent',
                        },
                    ]}
                />
            </ResultScreen>
        </PageFrame>
    );
};
